const convertTZ = (date: Date, tzString: string = 'America/New_York'): Date => {
    return new Date(date.toLocaleString('en-US', { timeZone: tzString }));
};

export default convertTZ;
